/* Jotform's iframe embed handler, rewritten with the origin check first. Jotform's own
   version acts on setHeight, scrollIntoView and reloadPage before it looks at e.origin,
   so any frame on the page can resize or reload it; its loadScript case is dropped
   outright, since a plain form has no reason to inject third-party script tags. */
(() => {
  const JOTFORM_ORIGIN = 'https://form.jotform.com';

  if (window.formEmbedBound) return;
  window.formEmbedBound = true;

  window.addEventListener('message', (event) => {
    if (event.origin !== JOTFORM_ORIGIN || typeof event.data !== 'string') return;

    const args = event.data.split(':');
    const frame = document.getElementById(`JotFormIFrame-${args[args.length - 1]}`);
    if (!frame) return;

    switch (args[0]) {
      case 'setHeight':
        // Releasing the reserve is what lets a short form stop short.
        frame.style.minHeight = '0';
        frame.style.height = `${args[1]}px`;
        break;
      case 'scrollIntoView':
        frame.scrollIntoView();
        break;
      case 'collapseErrorPage':
        if (frame.clientHeight > window.innerHeight) frame.style.height = `${window.innerHeight}px`;
        break;
      case 'reloadPage':
        window.location.reload();
        break;
      default:
        return;
    }

    // Jotform stamps each submission with the page it came from.
    frame.contentWindow?.postMessage(
      JSON.stringify({
        type: 'urls',
        value: {
          docurl: encodeURIComponent(document.URL),
          referrer: encodeURIComponent(document.referrer),
        },
      }),
      JOTFORM_ORIGIN
    );
  });
})();
